export const th = {
  nav_core: "หลัก",
  nav_analytics: "วิเคราะห์",
  nav_learning: "เรียนรู้",
  nav_tools: "เครื่องมือ",
  nav_more: "เพิ่มเติม",
  nav_ai_engine: "AI Engine",
  nav_coming_soon: "เร็ว ๆ นี้",
  nav_private: "ส่วนตัว",
  nav_home: "หน้าหลัก",
  nav_finances: "การเงิน",
  nav_my_finances: "การเงินของฉัน",
  nav_dashboard: "แดชบอร์ด",
  nav_holdings: "สินทรัพย์",
  nav_portfolio: "พอร์ต",
  nav_discover: "ค้นหา",
  nav_actions: "การดำเนินการ",
  nav_search: "ค้นหา",
  nav_review: "ทบทวน",
  nav_research_council: "สภาวิจัยพอร์ต",
  nav_cashflow: "กระแสเงินสด",
  nav_debt_optimizer: "ตัวช่วยจัดลำดับหนี้",
  nav_beam_academy: "BEAM Academy",
  nav_risk: "ความเสี่ยง",
  nav_watchlist: "รายการติดตาม",
  nav_thesis: "ธีสิส",
  nav_income: "รายได้",
  nav_net_worth: "มูลค่าสุทธิ",
  nav_relationships: "ความเชื่อมโยง",
  nav_allocation: "การจัดสรร",
  nav_stock_quality_score: "คะแนนคุณภาพหุ้น",
  nav_lens_score: "คะแนน Lens",
  nav_process_score: "คะแนนกระบวนการ",
  nav_import: "นำเข้า",
  nav_accounts: "บัญชี",
  nav_logout: "ออกจากระบบ",

  display_language: "ภาษาที่แสดง",
  display_language_help: "ภาษาหลักของเมนู หน้าเริ่มต้น และคำแนะนำสำคัญในแอป",
  language_updated: "อัปเดตภาษาแล้ว",
  language_update_failed: "อัปเดตภาษาไม่สำเร็จ",

  dashboard_title: "แดชบอร์ด",
  dashboard_subtitle: "ภาพรวมพอร์ตและตัวชี้วัดสำคัญ",
  dashboard_good_morning: "สวัสดีตอนเช้า",
  dashboard_based_on_profile: "อิงจาก",
  dashboard_attention_today: "นี่คือสิ่งที่อาจควรให้ความสนใจวันนี้",
  dashboard_learning_prompt_note: "คำแนะนำการเรียนรู้ใช้ข้อมูลในแอปเพื่อช่วยค้นคว้า ไม่ใช่คำสั่งหรือคำแนะนำให้ซื้อขาย",
  dashboard_estimated_surplus: "เงินส่วนเกินที่อาจลงทุนได้",
  dashboard_surplus_setup: "ตั้งค่า Cashflow Planner เพื่อยืนยันเงินที่ลงทุนได้จริง",
  dashboard_health_score: "สุขภาพการเงิน",
  dashboard_health_setup: "ตั้งค่า cashflow และ net worth เพื่อดู Financial Wellness",
  dashboard_growth_concentration: "ความกระจุกตัวในสินทรัพย์เติบโต",
  dashboard_growth_concentration_detail: "พอร์ตของคุณเอนเอียงไปทางธุรกิจเติบโตสูง ควรทบทวนธีม คุณภาพ และความไม่แน่นอนก่อนเพิ่มความเสี่ยง",
  dashboard_largest_concentration: "สัญญาณความกระจุกตัวหลัก",
  dashboard_portfolio_setup: "ตั้งค่าพอร์ต",
  dashboard_beam_gap_setup: "เพิ่มสินทรัพย์เพื่อดูช่องว่างของบทบาท BEAM",
  dashboard_beam_roles_visible: "เห็นบทบาท BEAM แล้ว",
  dashboard_beam_roles_visible_detail: "สินทรัพย์ปัจจุบันแสดงบทบาท BEAM หลักแล้ว ขั้นต่อไปคือทบทวนความกระจุกตัวและคุณภาพของธีสิส",
  dashboard_watchlist_study: "ชื่อหนึ่งจากรายการติดตามที่ควรศึกษา",
  dashboard_watchlist_study_detail: "เริ่มจากเข้าใจโมเดลธุรกิจ บริบทมูลค่า บทบาทในพอร์ต และความเสี่ยงก่อนตัดสินใจ",
  dashboard_holding_review: "ทบทวนสินทรัพย์ที่คุณถืออยู่หนึ่งรายการ",
  dashboard_holding_review_detail: "กลับมาดูว่าธุรกิจทำอะไร เหตุผลที่ถือ และหลักฐานอะไรที่จะเปลี่ยนธีสิส",
  dashboard_start_business: "เริ่มจากเข้าใจธุรกิจหนึ่งแห่ง",
  dashboard_start_business_detail: "เพิ่ม ticker หรือรายการติดตาม เพื่อให้แอปช่วยสร้างโจทย์การเรียนรู้",

  onboarding_salary_plan: "อิสรภาพทางการเงินเริ่มต้นเมื่อเงินเดือนมีแผน",
  onboarding_headline: "คุณอยากเข้าใจเรื่องอะไรก่อน?",
  onboarding_step_reason: "อะไรทำให้คุณมาที่นี่?",
  onboarding_step_learning: "คุณอธิบายสไตล์การลงทุนของตัวเองอย่างไร?",
  onboarding_step_insight: "เลือก insight แรกของคุณ",
  onboarding_step_frame: "กรอบคิดแรกใน Investing OS",
  onboarding_first_insight_fallback: "Insight แรก",
  onboarding_step_count: "ขั้นตอน",
  onboarding_step_of: "จาก",
  onboarding_based_on_profile: "อิงจาก",
  onboarding_learning_profile: "โปรไฟล์การค้นคว้า",
  learning_profile_cautious: "ระมัดระวัง",
  learning_profile_balanced: "สมดุล",
  learning_profile_aggressive: "เน้นเติบโต",
  onboarding_reason_start: "ฉันอยากเริ่มลงทุน",
  onboarding_reason_invest: "ฉันลงทุนอยู่แล้ว",
  onboarding_reason_portfolio: "ฉันอยากเข้าใจพอร์ตของตัวเอง",
  onboarding_reason_paycheck: "ฉันอยากเลิกใช้ชีวิตเดือนชนเดือน",
  onboarding_reason_business: "ฉันอยากเข้าใจธุรกิจก่อนซื้อ",
  onboarding_insight_cashflow: "เช็กว่าเงินส่วนไหนอาจลงทุนได้",
  onboarding_insight_business: "เข้าใจบริษัทหนึ่งแห่ง",
  onboarding_insight_portfolio: "ทบทวนสินทรัพย์ที่ถืออยู่",
  onboarding_insight_quality: "เรียนรู้คุณภาพเทียบกับ moonshot",
  onboarding_learning_cautious: "ปลอดภัยก่อน - อยากเติบโตมั่นคง ความเสี่ยงต่ำ",
  onboarding_learning_balanced: "สมดุล - เติบโตบ้าง ปลอดภัยบ้าง",
  onboarding_learning_aggressive: "เน้นเติบโต - รับความผันผวนได้",
  onboarding_learning_not_sure: "ยังไม่แน่ใจ",
  onboarding_learning_note: "โปรไฟล์ความเสี่ยงช่วยให้แอปอธิบาย tradeoff และจุดตรวจความปลอดภัยในการค้นคว้า ไม่ใช่คำแนะนำทางการเงินหรือการจัดพอร์ตอัตโนมัติ",
  onboarding_learning_description: "ใช้เป็นบริบทเพื่อการศึกษาและการค้นคว้าเท่านั้น ไม่ใช่คำแนะนำการลงทุน",
  onboarding_life_context_title: "อายุเป็นเพียงหนึ่งปัจจัย",
  onboarding_age_range_label: "ช่วงอายุ (ไม่บังคับ)",
  onboarding_life_stage_label: "ช่วงชีวิต (ไม่บังคับ)",
  onboarding_money_timeline_label: "ระยะเวลาที่อาจต้องใช้เงิน (ไม่บังคับ)",
  onboarding_cashflow_stability_label: "ความมั่นคงของกระแสเงินสด (ไม่บังคับ)",
  onboarding_obligations_context_label: "ภาระสำคัญ (ไม่บังคับ)",
  onboarding_principle_protect_title: "ปกป้องชีวิตก่อน",
  onboarding_principle_protect_copy: "อย่าลงทุนด้วยเงินที่ชีวิตยังต้องใช้",
  onboarding_principle_business_title: "เข้าใจธุรกิจ",
  onboarding_principle_business_copy: "เข้าใจสิ่งที่ถือ ก่อนถือเพิ่ม",
  onboarding_principle_study_title: "ศึกษาก่อนลงทุน",
  onboarding_principle_study_copy: "ก้าวต่อไปคือเรียนรู้ ไม่ใช่รีบซื้อ",
  onboarding_estimated_surplus: "ประมาณการเงินส่วนเกินรายเดือนที่อาจลงทุนได้",
  onboarding_estimate_warning: "นี่เป็นเพียงการประมาณ ไม่ใช่เงินลงทุนได้จริงที่ยืนยันแล้ว",
  onboarding_cashflow_cta: "ตั้งค่า Cashflow Planner เพื่อดูเงินที่ลงทุนได้จริง",
  onboarding_income_label: "รายได้ต่อเดือน",
  onboarding_income_placeholder: "ตัวอย่าง: 50000",
  onboarding_expenses_label: "ค่าใช้จ่ายจำเป็นต่อเดือน",
  onboarding_expenses_placeholder: "ค่าเช่า อาหาร ค่าสาธารณูปโภค",
  onboarding_obligations_label: "หนี้ / ภาระผูกพัน",
  onboarding_obligations_placeholder: "ยอดชำระขั้นต่ำ",
  onboarding_buffer_label: "เงินสำรองที่ต้องการ",
  onboarding_buffer_placeholder: "เป้าหมายเงินสำรองรายเดือน",
  onboarding_goals_label: "เงินสมทบเป้าหมายรายเดือน (ถ้ามี)",
  onboarding_goals_placeholder: "กองทุนเป้าหมาย ครอบครัว ท่องเที่ยว",
  onboarding_company_label: "Ticker หรือชื่อบริษัท",
  onboarding_company_placeholder: "ตัวอย่าง: AAPL, CPALL, Microsoft",
  onboarding_business_note: "เข้าใจว่าธุรกิจทำอะไรก่อนซื้อ",
  onboarding_business_detail: "เริ่มจากโมเดลธุรกิจ ความเสี่ยง บริบทมูลค่า และสิ่งที่จะเปลี่ยนธีสิสของคุณ",
  onboarding_portfolio_note: "เราต้องมีข้อมูลสินทรัพย์ก่อนจึงจะแสดงความกระจุกตัว ความเสี่ยง และบทบาทในพอร์ตได้",
  onboarding_portfolio_detail: "กรอกเองหรือนำเข้าก็พอ ไม่ต้องเชื่อมต่อโบรกเกอร์",
  onboarding_quality_note: "ธุรกิจคุณภาพกับ moonshot ไม่ใช่เกมเดียวกัน",
  onboarding_quality_detail: "ศึกษา moat โอกาส reinvest งบดุล มูลค่า และสิ่งที่อาจทำให้ธีสิสพัง",
  onboarding_first_frame_detail: "ตั้งค่า Cashflow Planner เพื่อยืนยันเงินที่ลงทุนได้จริง และใช้เครื่องมือค้นคว้าเพื่อศึกษาก่อนตัดสินใจ",

  disclaimer_short: "เพื่อการศึกษาเท่านั้น ไม่ใช่คำแนะนำทางการเงิน",
  disclaimer_full: "ข้อมูลนี้มีไว้เพื่อการศึกษาและช่วยค้นคว้าเท่านั้น ไม่ใช่คำแนะนำทางการเงิน ไม่ใช่คำแนะนำให้ซื้อหรือขาย และไม่รับประกันผลตอบแทน โปรดศึกษาด้วยตนเองและตัดสินใจขั้นสุดท้ายด้วยตัวเอง",
  disclaimer_personalized: "ปรับตามข้อมูลพอร์ตของคุณเพื่อการค้นคว้าเท่านั้น ไม่ใช่คำแนะนำทางการเงิน ไม่ใช่คำแนะนำให้ซื้อหรือขาย และไม่รับประกันผลตอบแทน โปรดศึกษาด้วยตนเองและตัดสินใจขั้นสุดท้ายด้วยตัวเอง",

  btn_back: "ย้อนกลับ",
  btn_cancel: "ยกเลิก",
  btn_continue: "ต่อ",
  btn_enter_app: "เข้า Investing OS",
  btn_generate: "สร้าง",
  btn_import: "นำเข้าสินทรัพย์",
  btn_manual: "เพิ่มเอง",
  btn_open_cashflow: "เปิด Cashflow Planner",
  btn_open_research: "เปิดหน้าค้นคว้าธุรกิจ",
  btn_explore: "สำรวจรายชื่อ",
  btn_save: "บันทึก",
  btn_skip: "ข้าม",
  btn_start_learning: "เริ่มเรียนรู้",
};
